const colors = {
    colorPrimary: '#12263e',
    colorMuted: '#3c4f65',
    colorRichBlue: '#2d6cfc',
    colorTeal: '#008080',
    colorFlameOrange: '#ffa500',
    colorSaphireBlue: '#2b49e3',
    colorIndigoViolet: '#800080',
    colorOceanicBlue: '#0085cc',
    colorWhite: '#fff',
    colorLightBlue: '#5d8fff',
    colorLightGrey: '#d8dce0',
    colorBgFilter: '#98a2b3',
    colorBlue: '#2b63e3',
    colorVividBlue: '#528bff',
    colorSlateBlue: '#b5c5d7',
    colorMediumBlue: '#00a0ff',
    colorFrostyAzure: '#cbd5e1',
    colorSkyBlue: '#55a1e5',
    colorVioletBlue: '#906df6',
    colorTurquoiseBlue: '#6cbdbf',
    colorGray: '#64748b',
    colorOrange: '#f69f29',
    colorSandyYellow: '#f8ce6b',
    colorRed: '#fd4c5c',
    colorCoralRed: '#ff5630',
    colorDarkRed: '#bf2600',
    colorMediumRed: '#dd636e',
    darkThemePrimary: '#007bff',
    darkThemeResolved: '#0056b3',
    colorRosePink: '#ed6e85',
    colorGreen: '#00c9bd',
    colorLightGreen: '#59c4c6',
    colorPrimaryHover: '#0F2239',
    colorSecondary: '#192D45',
    colorFilterTitle: '#94a3b8',
    colorMutedOrange: 'rgba(255, 168, 82, 0.20)',
    colorMutedBlue: 'rgba(82, 139, 255, 0.20)',
    colorZapier: '#ff4f00'
}

export {colors}
